import React, { FC, useCallback, useMemo } from "react";
import { getResultColumns, Grid } from "@getregistered/greg-editors";
import {
  gridLoader,
  GridLoadSuccessResponse,
} from "../../../domain/grid/resultLoader";
import { PaginatedApplicationGrid } from "../PaginatedApplicationGrid";
import { saveReport } from "./saveReport";
import { renderCheckinCell } from "../../grids/CheckinCell/renderCheckinCell";
import { DEFAULT_PER_PAGE, DEFAULT_PER_PAGE_STORAGE_KEY } from "../constants";
import { StaleFiltersModal } from "./StaleFiltersModal";
import { useStaleFilters } from "./useStaleFilters";

interface ReportGridResponse extends GridLoadSuccessResponse {
  staleFilters?: string[];
}

export interface PaginatedReportGridProps {
  grid: Grid;
  editable: boolean;
  reportUrl: string;
  totalsUrl: string;
  reportId?: number;
}

export const PaginatedReportGrid: FC<PaginatedReportGridProps> = ({
  grid,
  editable,
  reportUrl,
  totalsUrl,
  reportId,
}) => {
  const { showStaleFiltersModal, setShowStaleFiltersModal } = useStaleFilters(reportId);

  const handleFetchResults = useCallback((response: ReportGridResponse) => {
    if (response.staleFilters && response.staleFilters.length > 0) {
      setShowStaleFiltersModal(true);
    }
  }, [setShowStaleFiltersModal]);

  const columns = useMemo(
    () => getResultColumns(grid.columns),
    [grid.columns]
  );

  const loader = useMemo(
    () =>
      gridLoader<ReportGridResponse>(
        reportUrl,
        totalsUrl,
        columns,
        handleFetchResults
      ),
    [reportUrl, totalsUrl, columns, handleFetchResults]
  );
  const saveGrid = (update: Partial<Grid>) => saveReport(reportUrl, update);

  const processedGrid = editable
    ? grid
    : {
        ...grid,
        filters: undefined,
        fixedFilters: grid.filters,
      };

  return (
    <>
      <StaleFiltersModal isOpen={showStaleFiltersModal} />
      <PaginatedApplicationGrid
        grid={processedGrid}
        defaultPerPage={DEFAULT_PER_PAGE}
        perPageStorageKey={DEFAULT_PER_PAGE_STORAGE_KEY}
        page={1}
        loader={loader}
        onSave={editable ? saveGrid : undefined}
        renderCell={renderCheckinCell as any}
      />
    </>
  );
};
